import * as React from 'react';

const ChevronRightChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="chevron-right-chunky_svg__eds-icon--chevron-right-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="chevron-right-chunky_svg__eds-icon--chevron-right-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.2 17l5-5-5-5-1.4 1.4 3.6 3.6-3.6 3.6z"
        />
    </svg>
);

ChevronRightChunkySvg.displayName = 'ChevronRightChunkySvg';
export default ChevronRightChunkySvg;
